import {TinFormat} from '../model/Helper';
const PaperSignatoriesForPdf = (p1, p2)=>{

    let newP1=[], newP2=[];

    /**
     * Add party 1 spouses if any
     */
    p1.forEach((sig, i)=>{
        newP1.push(sig);
        // Seller
        if(
            sig.sellerFname 
            && sig.sellerMaritalStatus==="Married" 
            && sig.sellerHasRepresentative==="No"
            && sig.legalPersonality==="Natural Person"
        ){
            let spouse = {
                legalPersonality: sig.legalPersonality,
                isLegalAge: "Yes",
                sellerFname: sig.sellerSpouseFname,
                sellerMname: sig.sellerSpouseMname,
                sellerLname: sig.sellerSpouseLname,
                sellerSuffix: sig.sellerSpouseSuffix,
                sellerHasRepresentative: "No",
                sellerTin: sig.sellerSpouseTin,
                type: "seller"
            }
            newP1.push(spouse);
        }
        // Mortgagor
        if(
            sig.mortgagorFname 
            && sig.mortgagorMaritalStatus==="Married" 
            && sig.mortgagorHasRepresentative==="No"
            && sig.legalPersonality==="Natural Person"
        ){
            let spouse = {
                legalPersonality: sig.legalPersonality,
                isLegalAge: "Yes",
                mortgagorFname: sig.mortgagorSpouseFname,
                mortgagorMname: sig.mortgagorSpouseMname,
                mortgagorLname: sig.mortgagorSpouseLname,
                mortgagorSuffix: sig.mortgagorSpouseSuffix,
                mortgagorHasRepresentative: "No",
                mortgagorTin: sig.mortgagorSpouseTin,
                type: "mortgagor"
            }
            newP1.push(spouse);
        }

    });

    /**
     * Add party 2 spouses if any
     */
    p2.forEach((sig, i)=>{
        newP2.push(sig);
        //  Buyer
        if(
            sig.buyerFname 
            && sig.buyerMaritalStatus==="Married" 
            && sig.buyerHasRepresentative==="No"
            && sig.legalPersonality==="Natural Person"
        ){
            let spouse = {
                legalPersonality: sig.legalPersonality,
                isLegalAge: "Yes",
                buyerFname: sig.buyerSpouseFname,
                buyerMname: sig.buyerSpouseMname,
                buyerLname: sig.buyerSpouseLname,
                buyerSuffix: sig.buyerSpouseSuffix,
                buyerHasRepresentative: "No",
                buyerTin: sig.buyerSpouseTin,
                type: "buyer"
            }
            newP2.push(spouse);
        }
        // Mortgagee
        if(
            sig.mortgageeFname 
            && sig.mortgageeMaritalStatus==="Married" 
            && sig.mortgageeHasRepresentative==="No" 
            && sig.legalPersonality==="Natural Person"
        ){
            let spouse = {
                legalPersonality: sig.legalPersonality,
                isLegalAge: "Yes",
                mortgageeFname: sig.mortgageeSpouseFname,
                mortgageeMname: sig.mortgageeSpouseMname,
                mortgageeLname: sig.mortgageeSpouseLname,
                mortgageeSuffix: sig.mortgageeSpouseSuffix,
                mortgageeHasRepresentative: "No",
                mortgageeTin: sig.mortgageeSpouseTin,
                type: "mortgagee"
            }
            newP2.push(spouse);
        }
    });

    /**
     * Join buyer and seller; lender and borrower
     */
    const signatories = [...new Set([...newP1, ...newP2])];

    let allSignatures=`<table class="table-even"><tbody><tr>`;

    signatories.forEach((sig, i)=>{

        let blankLine = "____________________";
        let name = blankLine, 
            type = blankLine, 
            representativeName = blankLine, 
            hasRepresentative = blankLine;
        let tin, tinRepresentative;

        if(sig.legalPersonality==="Natural Person") {
            if(sig.sellerFname){
                name = `${sig.sellerFname} ${sig.sellerMname} ${sig.sellerLname} ${sig.sellerSuffix}`;
                hasRepresentative = sig.sellerHasRepresentative;
                if(sig.sellerMaritalStatus==="Married" && hasRepresentative==="Yes"){
                    name+=` and ${sig.sellerSpouseFname} ${sig.sellerSpouseMname} ${sig.sellerSpouseLname} ${sig.sellerSpouseSuffix}`
                }
                representativeName = `${sig.sellerRepresentativeFname} ${sig.sellerRepresentativeMname} ${sig.sellerRepresentativeLname} ${sig.sellerRepresentativeSuffix}`;
                type = "Seller";
                tin = sig.sellerTin;
                tinRepresentative = sig.sellerRepresentativeTin;
            }
            if(sig.buyerFname) {
                name = `${sig.buyerFname} ${sig.buyerMname} ${sig.buyerLname} ${sig.buyerSuffix}`;
                hasRepresentative = sig.buyerHasRepresentative;
                if(sig.buyerMaritalStatus==="Married" && hasRepresentative==="Yes"){
                    name+=` and ${sig.buyerSpouseFname} ${sig.buyerSpouseMname} ${sig.buyerSpouseLname} ${sig.buyerSpouseSuffix}`
                }
                representativeName = `${sig.buyerRepresentativeFname} ${sig.buyerRepresentativeMname} ${sig.buyerRepresentativeLname} ${sig.buyerRepresentativeSuffix}`;
                type = "Buyer";
                tin = sig.buyerTin;
                tinRepresentative = sig.buyerRepresentativeTin;
            }
            if(sig.mortgagorFname){
                name = `${sig.mortgagorFname} ${sig.mortgagorMname} ${sig.mortgagorLname} ${sig.mortgagorSuffix}`;
                hasRepresentative = sig.mortgagorHasRepresentative;
                if(sig.mortgagorMaritalStatus==="Married" && hasRepresentative==="Yes"){
                    name+=` and ${sig.mortgagorSpouseFname} ${sig.mortgagorSpouseMname} ${sig.mortgagorSpouseLname} ${sig.mortgagorSpouseSuffix}`
                }
                representativeName = `${sig.mortgagorRepresentativeFname} ${sig.mortgagorRepresentativeMname} ${sig.mortgagorRepresentativeLname} ${sig.mortgagorRepresentativeSuffix}`;
                type = "Mortgagor";
                tin = sig.mortgagorTin;
                tinRepresentative = sig.mortgagorRepresentativeTin;
            }
            if(sig.mortgageeFname){
                name = `${sig.mortgageeFname} ${sig.mortgageeMname} ${sig.mortgageeLname} ${sig.mortgageeSuffix}`;
                hasRepresentative = sig.mortgageeHasRepresentative;
                if(sig.mortgageeMaritalStatus==="Married" && hasRepresentative==="Yes"){
                    name+=` and ${sig.mortgageeSpouseFname} ${sig.mortgageeSpouseMname} ${sig.mortgageeSpouseLname} ${sig.mortgageeSpouseSuffix}`
                }
                representativeName = `${sig.mortgageeRepresentativeFname} ${sig.mortgageeRepresentativeMname} ${sig.mortgageeRepresentativeLname} ${sig.mortgageeRepresentativeSuffix}`;
                type = "Mortgagee";
                tin = sig.mortgageeTin;
                tinRepresentative = sig.mortgageeRepresentativeTin;
            }
        } else {
            if(sig.sellerCorporationName){
                name = sig.sellerCorporationName;
                representativeName = `${sig.sellerCorporationRepresentativeFname} ${sig.sellerCorporationRepresentativeMname} ${sig.sellerCorporationRepresentativeLname} ${sig.sellerCorporationRepresentativeSuffix}`;
                type = "Seller";
                tin = sig.sellerCorporationTin;
            } 
            if(sig.buyerCorporationName){
                name = sig.buyerCorporationName;
                representativeName = `${sig.buyerCorporationRepresentativeFname} ${sig.buyerCorporationRepresentativeMname} ${sig.buyerCorporationRepresentativeLname} ${sig.buyerCorporationRepresentativeSuffix}`;
                type = "Buyer";
                tin = sig.buyerCorporationTin;
            }
            if(sig.mortgagorCorporationName){
                name = sig.mortgagorCorporationName;
                representativeName = `${sig.mortgagorCorporationRepresentativeFname} ${sig.mortgagorCorporationRepresentativeMname} ${sig.mortgagorCorporationRepresentativeLname} ${sig.mortgagorCorporationRepresentativeSuffix}`;
                type = "Mortgagor";
                tin = sig.mortgagorCorporationTin;
            }
            if(sig.mortgageeCorporationName){
                name = sig.mortgageeCorporationName;
                representativeName = `${sig.mortgageeCorporationRepresentativeFname} ${sig.mortgageeCorporationRepresentativeMname} ${sig.mortgageeCorporationRepresentativeLname} ${sig.mortgageeCorporationRepresentativeSuffix}`;
                type = "Mortgagee";
                tin = sig.mortgageeCorporationTin;
            }
        }

        tin = TinFormat(tin);

        allSignatures+=`
            ${signatories.length<2?`<td>&nbsp;</td>`:``}
            <td>
                <div class="py-1 mb-3 text-center signature-block" key=${i}>
                    <div class=${sig.legalPersonality==="Natural Person"?``:`d-none`}>

                        <div class=${hasRepresentative==="Yes"?``:`d-none`}>
                            <table class="w-100">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div class="sign-top">
                                                <span class="dynamic-data font-weight-bold text-uppercase">${name}</span> <br />
                                                <span class="font-italic">${type}</span>
                                                ${tin?`<span><br />TIN: ${tin}</span>`:`<span>&nbsp;</span>`}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="sign-space">
                                                <div class="pt-5 text-left">by:</div>
                                                <div class="blank-line-long "></div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="sign-here">
                                                <span class="dynamic-data font-weight-bold text-uppercase">${representativeName}</span> <br />
                                                <div class="font-italic">Attorney-in-fact</div>
                                                ${tinRepresentative?`<span><br />TIN: ${tinRepresentative}</span>`:`<span>&nbsp;</span>`}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class=${hasRepresentative==="No"?``:`d-none`}>
                            <table class="w-100">
                                <tr>
                                    <td>
                                        <div class="sign-top">
                                            <span class="dynamic-data font-weight-bold text-uppercase">&nbsp;</span> <br />
                                            &nbsp;
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="sign-space">
                                            <div class="pt-5 text-left">&nbsp;</div>
                                            <div class="blank-line-long "></div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="sign-here">
                                            <span class="dynamic-data font-weight-bold text-uppercase">${name}</span> <br />
                                            <span class="font-italic">${type}</span>
                                            ${tin?`<span><br />TIN: ${tin}</span>`:`<span>&nbsp;</span>`}
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        
                    </div>
                    <div class=${sig.legalPersonality==="Corporation"?``:`d-none`}>
                        <table class="w-100">
                            <tr>
                                <td>
                                    <div class="sign-top">
                                        <span class="dynamic-data font-weight-bold text-uppercase">${name}</span> <br />
                                        <span class="font-italic">${type}</span>
                                        ${tin?`<span><br />TIN: ${tin}</span>`:`<span>&nbsp;</span>`}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="sign-space">
                                        <div class="pt-5 text-left">by:</div>
                                        <div class="blank-line-long "></div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="sign-here">
                                        <div class="dynamic-data font-weight-bold text-uppercase">${representativeName}</div>
                                        <div class="font-italic">Attorney-in-fact</div>
                                        ${tin?`<span><br />&nbsp;</span>`:`<span>&nbsp;</span>`}
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </td>`;
            if((i+1)%2===0) {allSignatures+=`</tr><tr>`}
        
    })
                         
    allSignatures+=`</tr></tbody></table>`;
    return allSignatures;
}

export default PaperSignatoriesForPdf;



// WEBPACK FOOTER //
// ./src/model/PaperSignatoriesForPdf.js